import { useTranslate } from '@tolgee/react';
import OffenseListPage, {
  PageProps,
  getServerSideProps as fetcher,
} from '@amf/shared/pages/OffenseListPage';

import Layout from 'components/layout/Layout';
import Meta from 'components/Meta';
import { AppLinks } from 'utils/links';

export default function Page({ navigation, partners, seasons }: PageProps) {
  const { t } = useTranslate();
  return (
    <div className='OffenseListPage'>
      <Layout navigation={navigation} partners={partners}>
        <Meta title={t('offense.list.title')} />
        <OffenseListPage seasons={seasons} links={{ offenses: AppLinks.offenses }} />
      </Layout>
    </div>
  );
}

export const getServerSideProps = fetcher();
